import store from "../store";
import axiosUrl from "./axios.service";
import axios from "axios";

const API_URL = axiosUrl.getAxiosUrl();
const AI_ASSISTANT_PROCESSOR_URL =
  process.env.VUE_APP_AI_ASSISTANT_PROCESSOR_URL;

class AIAssistantService {
  getAIAssistantAccessToken() {
    return axios.post(API_URL + "/users/getAIAssistantAccessToken");
  }

  async processPrompt(conversation, locale, noResultsText) {
    const payload = conversation.map((message) => ({
      messageId: message.id,
      role: message.author.id,
      conversationId: store.state.chat.currentConversationId, // CHECK
      timestamp: message.timestamp,
      content: message.text,
    }));

    return await axios
      .post(
        AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/processPrompt",
        {
          messages: payload,
          locale: locale,
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.chat.aiAssistantAccessToken.accessToken}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            store.dispatch("chat/addAssistantMessage", response.data.content);

            // If any error occurs on the server side, we don't pass it along to the client side. 
            // Instead, we pass the user-friendly message along to the client side as the content of the successful HTTP response, and start a new conversation
            if (response.data.content === noResultsText)
              store.dispatch("chat/startNewConversation");
          }
        }
      })
      // If any other error (that couldn't be handled by the server) occurs, we dom't show any explicit error message to the user. 
      // Instead, we display a 'no results' message and start a new conversation.
      .catch(() => {
        store.dispatch("chat/addAssistantMessage", noResultsText);
        // TODO: Analytics should be inserted?
        store.dispatch("chat/startNewConversation");
      });
  }

  async getAISettings() {
    return await axios.get(API_URL + "/ai/getAISettings").then((response) => {
      if (response.status === 200) {
        store.commit("chat/fillSettings", response.data);
      }
    });
  }

  async getUserConversations() {
    return await axios
      .get(API_URL + "/ai/getUserConversations")
      .then((response) => {
        if (response.status === 200) {
          store
            .commit(
              "chat/updateChatHistoryMessages",
              response.data.conversations,
            )
            .catch((error) => {
              if (error)
                store.commit("auth/updateModalError", error.response.data),
                  store.commit("auth/enableModalError");
            });
        }
      });
  }

  async getMessagesByConversation(conversationId) {
    return await axios
      .get(API_URL + "/ai/getMessagesFromConversation", {
        params: {
          conversationId: conversationId,
        },
      })
      .then((response) => {
        store.commit("chat/setMessagesFromSelectedConversation", response.data);
      })
      .catch((error) => {
        if (error) store.commit("auth/updateModalError", error.response.data);
        store.commit("auth/enableModalError");
      });
  }

  async getMessagesByConversations(conversationIds) {
    return await axios
      .post(API_URL + "/ai/getMessagesFromConversations", {
        conversationIds: conversationIds,
      })
      .then((response) => {
        if (response.status === 200)
          store.commit(
            "chat/setMessagesPerConversation",
            response.data.messagesByConversation,
          );
      })
      .catch((error) => {
        throw error;
      });
  }
}

export default new AIAssistantService();
